import(/* webpackMode: "eager" */ "C:\\Users\\Caleb\\Development\\xampp\\htdocs\\ifueltax-static\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Caleb\\Development\\xampp\\htdocs\\ifueltax-static\\src\\components\\Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Caleb\\Development\\xampp\\htdocs\\ifueltax-static\\src\\components\\IftaCalculator.jsx");
